const CreateUserAPI = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return !response.ok ? 400 : 201;
  } catch (error) {
    console.error("Fetch error:", error);
    return 400;
  }
};

export default CreateUserAPI;
